module.exports = "<div class=\"welcome-container\"><router-outlet></router-outlet></div>\n"